import React from 'react';
import { Module } from 'shared/prisma/types';

import { CollectionActivityAlerts } from 'components/CollectionActivityStatus';
import SurveysCard from '../Survey/SurveysCard';
import AnalyticsCard from '../LegacyAnalytics/AnalyticsCard';
import HsrCard from '../Hsr/HsrCard';
import AccessibilityCard from '../AccessibilityReview/AccessibilityCard';

const Website = ({
  dataSourceId,
  collectionActivity,
  activeLicense,
  dataSourceType,
  isDemo,
  isTest,
}) => (
  <>
    {!isDemo && !isTest && (
      <CollectionActivityAlerts
        collectionActivity={collectionActivity}
        activeLicense={activeLicense}
        dataSourceType={dataSourceType}
        dataSourceId={dataSourceId}
        showScriptInstructions
      />
    )}
    <AnalyticsCard />
    <HsrCard isDemo={isDemo} />
    <SurveysCard module={Module.UxSurveys} />
    <AccessibilityCard />
  </>
);

export default Website;
